
import { searchField } from "@/stores/makePaginatedTable";

export default function makeVuexTable({ name = "Table",
    store,
    provide = false,
    fetchOnMounted = true,
    fields = {} }) {

    const computedSearch = {};
    for (const key of Object.keys(fields)) {
        const fieldname = fields[key];
        const property = `${store}/${searchField(fieldname)}`;
        const updateSearchParameters = `${store}/updateSearchParameters`;
        computedSearch[key] = {
            get() {
                return this.$store.getters[property];
            },
            set(value) {
                return this.$store.dispatch(updateSearchParameters, { field: fieldname, value });
            }
        }
    }


    const disableFetch = `disableFetch${name}`;
    const disableFetchKey = `${store}/${disableFetch}`;

    const out = {
        computed: {
            ...computedSearch,
            [disableFetch]: {
                get() {
                    return this.$store.getters[disableFetchKey];
                },
                set(disabled) {
                    this.$store.commit(disableFetchKey, disabled);
                }
            }
        }
    };

    if (fetchOnMounted) {
        out.mounted = function () {
            this.$store.dispatch(`${store}/firstFetch`);
        }
    }

    if (provide) {
        out.provide = function () {
            return {
                dataTableStoreName: store,
            };
        };
    }

    return out;

}
